export default __webpack_public_path__ + "static/blog2-c87a782ff77a9fc84bbbef10573f6e5f.jpeg";